var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex flex-col w-full bg-white shadow-md hover:shadow-xl mb-5 transition delay-75 duration-200 ease-in-out rounded-xl",
      class: _vm.optionalClasses,
    },
    [
      _c(
        "div",
        {
          staticClass:
            "h-10 bg-gray-200 flex rounded-xl pl-4 font-bold items-center text-semibold space-x-4 justify-between",
        },
        [_vm._t("header")],
        2
      ),
      _c(
        "div",
        { staticClass: "flex w-full p-4 flex-wrap grow", class: _vm.bgClasses },
        [_vm._t("default")],
        2
      ),
      _vm.$scopedSlots.footer
        ? _c(
            "div",
            { staticClass: "mt-auto h-28", class: _vm.actionBarStyles },
            [_vm._t("footer")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }